<template>
  <div class="modal-card" ref="element">
    <header class="modal-card-head">
      <p class="modal-card-title">Edit App Menu Item {{ this.itemIndex + 1 }}</p>
    </header>
    <section class="modal-card-body">
      <b-field v-if="bFieldsError" style="color: red">
        Please fill in all fields.
      </b-field>
      <b-field v-if="bFilesError" style="color: red">
        {{ bFilesMessage }}
      </b-field>
      <b-field label="Type:">
        <b-select v-model="appMenuItemType">
          <option value="questionnaire">Questionnaire</option>
          <option value="doubleWeb">Double Web</option>
          <option value="singleQR">Single QR</option>
          <option value="doubleQR">Double QR</option>
          <option value="pdf">Documents</option>
          <option value="mosaic">Mosaic</option>
        </b-select>
      </b-field>

      <div v-if="appMenuItemType != ''" style="padding-bottom: 12px;">
        <b-field label="App Item Title:">
          <b-input type="text" v-model="appItemTitle" placeholder="App Item Title:"
            :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="App Item Title (Albanian):">
          <b-input type="text" v-model="appItemTitleAl" placeholder="App Item Title (Albanian)"
            :disabled="role === 'viewer'"></b-input>
        </b-field>
      </div>

      <div v-if="appMenuItemType == 'questionnaire'">
        <b-field label="Questionnaire:">
          <b-select :disabled="role === 'viewer'" id="questionnaireId" v-model="questionnaireId">
            <option v-for="(questionnaire, id) in questionnaires" :key="id" :value="id">{{ questionnaire.name }}</option>
          </b-select>
        </b-field>
      </div>

      <div v-if="appMenuItemType == 'pdf'">
        <b-field label="Documents title:">
          <b-input type="text" v-model="documentsTitle" placeholder="Documents title:" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Documents title (Albanian):">
          <b-input type="text" v-model="documentsTitleAl" placeholder="Documents title (Albanian):" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Title 1:">
          <b-input type="text" v-model="title1" placeholder="Title 1:" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Title 1 (Albanian):">
          <b-input type="text" v-model="title1Al" placeholder="Title 1 (Albanian):" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Title 2:">
          <b-input type="text" v-model="title2" placeholder="Title 2:" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Title 2 (Albanian):">
          <b-input type="text" v-model="title2Al" placeholder="Title 2 (Albanian):" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Description 1:">
          <b-input type="text" v-model="description1" placeholder="Description 1:" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Description 1 (Albanian):">
          <b-input type="text" v-model="description1Al" placeholder="Description 1 (Albanian):" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Description 2:">
          <b-input type="text" v-model="description2" placeholder="Description 2:" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Description 2 (Albanian):">
          <b-input type="text" v-model="description2Al" placeholder="Description 2 (Albanian):" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="URL:">
          <b-input type="text" v-model="url" placeholder="URL" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field style="font-size: small;">
          Valid format: (http://www.example.com)
        </b-field>
        <b-field>
          For uploading PDFs, please refer to the "PDFs" page from the menu.
        </b-field>
      </div>

      <div v-if="appMenuItemType == 'mosaic'">
        <b-field label="Choose file for image 1:">
        </b-field>
        <div class="bottomPadding">
        <b-button :disabled="role === 'viewer'" icon-left="file-upload" type="is-primary" outlined @click="addFile1()">
          Local storage
        </b-button>
        </div>
        <b-field v-if="itemFiles1.length > 0">
          Chosen file: {{ itemFiles1[0].name }}
        </b-field>
        <b-field v-if="resourceName1.length > 0 && imageUrl1.length > 0">
          <b>Currently uploaded file:</b> {{ resourceName1 }}
        </b-field>
        <b-field v-if="resourceName1.length > 0 && imageUrl1.length > 0">
          <img :src="imageUrl1" width="275">
        </b-field>
        <b-field label="Web URL 1:">
          <b-input type="text" v-model="webUrl1" placeholder="Web URL 1" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field style="font-size: small;">
          Valid format: (http://www.example.com)
        </b-field>

        <b-field label="Choose file for image 2:">
        </b-field>
        <div class="bottomPadding">
        <b-button :disabled="role === 'viewer'" icon-left="file-upload" type="is-primary" outlined @click="addFile2()">
          Local storage
        </b-button>
        </div>
        <b-field v-if="itemFiles2.length > 0">
          Chosen file: {{ itemFiles2[0].name }}
        </b-field>
        <b-field v-if="resourceName2.length > 0 && imageUrl2.length > 0">
          <b>Currently uploaded file:</b> {{ resourceName2 }}
        </b-field>
        <b-field v-if="resourceName2.length > 0 && imageUrl2.length > 0">
          <img :src="imageUrl2" width="275">
        </b-field>
        <b-field label="Web URL 2:">
          <b-input type="text" v-model="webUrl2" placeholder="Web URL 2" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field style="font-size: small;">
          Valid format: (http://www.example.com)
        </b-field>

        <b-field label="Choose file for image 3:">
        </b-field>
        <div class="bottomPadding">
        <b-button :disabled="role === 'viewer'" icon-left="file-upload" type="is-primary" outlined @click="addFile3()">
          Local storage
        </b-button>
        </div>
        <b-field v-if="itemFiles3.length > 0">
          Chosen file: {{ itemFiles3[0].name }}
        </b-field>
        <b-field v-if="resourceName3.length > 0 && imageUrl3.length > 0">
          <b>Currently uploaded file:</b> {{ resourceName3 }}
        </b-field>
        <b-field v-if="resourceName3.length > 0 && imageUrl3.length > 0">
          <img :src="imageUrl3" width="275">
        </b-field>
        <b-field label="Web URL 3:">
          <b-input type="text" v-model="webUrl3" placeholder="Web URL 3" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field style="font-size: small;">
          Valid format: (http://www.example.com)
        </b-field>

        <b-field label="Choose file for image 4:">
        </b-field>
        <div class="bottomPadding">
        <b-button :disabled="role === 'viewer'" icon-left="file-upload" type="is-primary" outlined @click="addFile4()">
          Local storage
        </b-button>
        </div>
        <b-field v-if="itemFiles4.length > 0">
          Chosen file: {{ itemFiles4[0].name }}
        </b-field>
        <b-field v-if="resourceName4.length > 0 && imageUrl4.length > 0">
          <b>Currently uploaded file:</b> {{ resourceName4 }}
        </b-field>
        <b-field v-if="resourceName4.length > 0 && imageUrl4.length > 0">
          <img :src="imageUrl4" width="275">
        </b-field>
        <b-field label="Web URL 4:">
          <b-input type="text" v-model="webUrl4" placeholder="Web URL 4" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field style="font-size: small;">
          Valid format: (http://www.example.com)
        </b-field>

        <b-field label="Choose file for image 5:">
        </b-field>
        <div class="bottomPadding">
        <b-button :disabled="role === 'viewer'" icon-left="file-upload" type="is-primary" outlined @click="addFile5()">
          Local storage
        </b-button>
        </div>
        <b-field v-if="itemFiles5.length > 0">
          Chosen file: {{ itemFiles5[0].name }}
        </b-field>
        <b-field v-if="resourceName5.length > 0 && imageUrl5.length > 0">
          <b>Currently uploaded file:</b> {{ resourceName5 }}
        </b-field>
        <b-field v-if="resourceName5.length > 0 && imageUrl5.length > 0">
          <img :src="imageUrl5" width="275">
        </b-field>
        <b-field label="Web URL 5:">
          <b-input type="text" v-model="webUrl5" placeholder="Web URL 5" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field style="font-size: small;">
          Valid format: (http://www.example.com)
        </b-field>

        <b-field label="Choose file for image 6:">
        </b-field>
        <div class="bottomPadding">
        <b-button :disabled="role === 'viewer'" icon-left="file-upload" type="is-primary" outlined @click="addFile6()">
          Local storage
        </b-button>
        </div>
        <b-field v-if="itemFiles6.length > 0">
          Chosen file: {{ itemFiles6[0].name }}
        </b-field>
        <b-field v-if="resourceName6.length > 0 && imageUrl6.length > 0">
          <b>Currently uploaded file:</b> {{ resourceName6 }}
        </b-field>
        <b-field v-if="resourceName6.length > 0 && imageUrl6.length > 0">
          <img :src="imageUrl6" width="275">
        </b-field>
        <b-field label="Web URL 6:">
          <b-input type="text" v-model="webUrl6" placeholder="Web URL 6" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field style="font-size: small;">
          Valid format: (http://www.example.com)
        </b-field>
      </div>

      <div v-if="appMenuItemType == 'doubleWeb'">
        <b-field label="Title 1:">
          <b-input type="text" v-model="title1" placeholder="Title 1" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Title 1 (Albanian):">
          <b-input type="text" v-model="title1Al" placeholder="Title 1 (Albanian)"
            :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Title 2:">
          <b-input type="text" v-model="title2" placeholder="Title 2" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Title 2 (Albanian):">
          <b-input type="text" v-model="title2Al" placeholder="Title 2 (Albanian)"
            :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Description 1:">
            <b-input :disabled="role === 'viewer'" type="textarea" v-model="description1" placeholder="Description 1"></b-input>
          </b-field>
          <b-field label="Description 1 (Albanian):">
            <b-input :disabled="role === 'viewer'" type="textarea" v-model="description1Al" placeholder="Description 1 (Albanian)"></b-input>
          </b-field>
          <b-field label="Description 2:">
            <b-input :disabled="role === 'viewer'" type="textarea" v-model="description2" placeholder="Description 2"></b-input>
          </b-field>
          <b-field label="Description 2 (Albanian):">
            <b-input :disabled="role === 'viewer'" type="textarea" v-model="description2Al" placeholder="Description 2 (Albanian)"></b-input>
          </b-field>
        <b-field label="URL 1:">
          <b-input type="text" v-model="url1" placeholder="URL 1" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field style="font-size: small;">
          Valid format: (http://www.example.com)
        </b-field>
        <b-field label="URL 2:">
          <b-input type="text" v-model="url2" placeholder="URL 2" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field style="font-size: small;">
          Valid format: (http://www.example.com)
        </b-field>
      </div>

      <div v-if="appMenuItemType == 'singleQR' || appMenuItemType == 'doubleQR'">
        <b-field label="Title:">
          <b-input type="text" v-model="title" placeholder="Title" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Title (Albanian):">
          <b-input type="text" v-model="titleAl" placeholder="Title (Albanian)" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <div v-if="appMenuItemType == 'singleQR'" style="padding-bottom: 12px">
          <b-field label="Subtitle:">
            <b-input type="text" v-model="subtitle" placeholder="Subtitle" :disabled="role === 'viewer'"></b-input>
          </b-field>
          <b-field label="Subtitle (Albanian):">
            <b-input type="text" v-model="subtitleAl" placeholder="Subtitle (Albanian)"
              :disabled="role === 'viewer'"></b-input>
          </b-field>
        </div>
        <div v-else style="padding-bottom: 12px;">
          <b-field label="Subtitle 1:">
            <b-input type="text" v-model="subtitle1" placeholder="Subtitle 1" :disabled="role === 'viewer'"></b-input>
          </b-field>
          <b-field label="Subtitle 1 (Albanian):">
            <b-input type="text" v-model="subtitle1Al" placeholder="Subtitle 1 (Albanian)"
              :disabled="role === 'viewer'"></b-input>
          </b-field>
          <b-field label="Subtitle 2:">
            <b-input type="text" v-model="subtitle2" placeholder="Subtitle 2" :disabled="role === 'viewer'"></b-input>
          </b-field>
          <b-field label="Subtitle 2 (Albanian):">
            <b-input type="text" v-model="subtitle2Al" placeholder="Subtitle 2 (Albanian)"
              :disabled="role === 'viewer'"></b-input>
          </b-field>
        </div>
        <b-field label="Description:">
          <b-input type="text" v-model="description" placeholder="Description" :disabled="role === 'viewer'"></b-input>
        </b-field>
        <b-field label="Description (Albanian):">
          <b-input type="text" v-model="descriptionAl" placeholder="Description (Albanian)"
            :disabled="role === 'viewer'"></b-input>
        </b-field>
        <div v-if="appMenuItemType == 'singleQR'">
          <b-field label="URL:">
            <b-input type="text" v-model="url" placeholder="URL" :disabled="role === 'viewer'"></b-input>
          </b-field>
          <b-field style="font-size: small;">
            Valid format: (http://www.example.com)
          </b-field>
          <b-switch :disabled="role === 'viewer'" v-model="clickable">Clickable?</b-switch>
        </div>
        <div v-else>
          <b-field label="URL 1:">
            <b-input type="text" v-model="url1" placeholder="URL 1" :disabled="role === 'viewer'"></b-input>
          </b-field>
          <b-field style="font-size: small;">
            Valid format: (http://www.example.com)
          </b-field>
          <b-field label="URL 2:">
            <b-input type="text" v-model="url2" placeholder="URL 2" :disabled="role === 'viewer'"></b-input>
          </b-field>
          <b-field style="font-size: small;">
            Valid format: (http://www.example.com)
          </b-field>
          <b-switch :disabled="role === 'viewer'" v-model="clickable">Clickable?</b-switch>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <b-button type="is-info" @click="saveAppMenuItem" :disabled="role === 'viewer'">Submit</b-button>
      <b-button type="is-light" @click="closeModal()">Cancel</b-button>
      <input style="display: none" @change="fileUploaded" id="fileSelect" name="fileSelect" type="file">
      <input style="display: none" @change="file1Uploaded" id="file1Select" name="file1Select" type="file">
      <input style="display: none" @change="file2Uploaded" id="file2Select" name="file2Select" type="file">
      <input style="display: none" @change="file3Uploaded" id="file3Select" name="file3Select" type="file">
      <input style="display: none" @change="file4Uploaded" id="file4Select" name="file4Select" type="file">
      <input style="display: none" @change="file5Uploaded" id="file5Select" name="file5Select" type="file">
      <input style="display: none" @change="file6Uploaded" id="file6Select" name="file6Select" type="file">
    </footer>
  </div>
</template>
<script>

export default {
  name: 'AppMenuItemEdit',
  props: ['propId', 'propAppMenuItemData'],
  data: () => {
    return {
      editStaticAppMenuItemRef: {},
      itemIndex: 0,
      appMenuItemType: '',
      appItemTitle: '',
      appItemTitleAl: '',
      title1: '',
      title2: '',
      title1Al: '',
      title2Al: '',
      url1: '',
      url2: '',
      title: '',
      titleAl: '',
      subtitle: '',
      subtitleAl: '',
      subtitle1: '',
      subtitle1Al: '',
      subtitle2: '',
      subtitle2Al: '',
      description: '',
      descriptionAl: '',
      description1: '',
      description1Al: '',
      description2: '',
      description2Al: '',
      url: '',
      pdfUrl: '',
      clickable: false,
      questionnaireId: '',
      itemFiles: [],
      itemFiles1: [],
      itemFiles2: [],
      itemFiles3: [],
      itemFiles4: [],
      itemFiles5: [],
      itemFiles6: [],
      resourceName: '',
      resourceName1: '',
      resourceName2: '',
      resourceName3: '',
      resourceName4: '',
      resourceName5: '',
      resourceName6: '',
      bFileError: false,
      bFileMessage: '',
      bFieldsError: false,
      bFilesError: false,
      bFilesMessage: '',
      isAddMosaic: true,
      pdfId: '',
      webUrl1: '',
      webUrl2: '',
      webUrl3: '',
      webUrl4: '',
      webUrl5: '',
      webUrl6: '',
      documentsTitle: '',
      documentsTitleAl: ''
    }
  },
  mounted: function () {
    this.itemIndex = this.propId
    if (this.propAppMenuItemData !== null) {
      this.editStaticAppMenuItemRef = this.propAppMenuItemData
      if (this.editStaticAppMenuItemRef) {
        this.appMenuItemType = this.editStaticAppMenuItemRef.type
        this.appItemTitle = this.editStaticAppMenuItemRef.appItemTitle
        this.appItemTitleAl = this.editStaticAppMenuItemRef.appItemTitleAl
        switch (this.appMenuItemType) {
          case 'questionnaire':
            this.questionnaireId = this.editStaticAppMenuItemRef.questionnaireId
            break
          case 'doubleWeb':
            this.title1 = this.editStaticAppMenuItemRef.title1
            this.title1Al = this.editStaticAppMenuItemRef.title1Al
            this.title2 = this.editStaticAppMenuItemRef.title2
            this.title2Al = this.editStaticAppMenuItemRef.title2Al
            this.url1 = this.editStaticAppMenuItemRef.url1
            this.url2 = this.editStaticAppMenuItemRef.url2
            this.description1 = this.editStaticAppMenuItemRef.desc1
            this.description1Al = this.editStaticAppMenuItemRef.desc1Al
            this.description2 = this.editStaticAppMenuItemRef.desc2
            this.description2Al = this.editStaticAppMenuItemRef.desc2Al
            break
          case 'singleQR':
            this.title = this.editStaticAppMenuItemRef.title
            this.titleAl = this.editStaticAppMenuItemRef.titleAl
            this.subtitle = this.editStaticAppMenuItemRef.subTitle
            this.subtitleAl = this.editStaticAppMenuItemRef.subTitleAl
            this.description = this.editStaticAppMenuItemRef.desc
            this.descriptionAl = this.editStaticAppMenuItemRef.descAl
            this.url = this.editStaticAppMenuItemRef.url
            this.clickable = this.editStaticAppMenuItemRef.clickable
            break
          case 'doubleQR':
            this.title = this.editStaticAppMenuItemRef.title
            this.titleAl = this.editStaticAppMenuItemRef.titleAl
            this.subtitle1 = this.editStaticAppMenuItemRef.subTitle1
            this.subtitle1Al = this.editStaticAppMenuItemRef.subTitle1Al
            this.subtitle2 = this.editStaticAppMenuItemRef.subTitle2
            this.subtitle2Al = this.editStaticAppMenuItemRef.subTitle2Al
            this.description = this.editStaticAppMenuItemRef.desc
            this.descriptionAl = this.editStaticAppMenuItemRef.descAl
            this.url1 = this.editStaticAppMenuItemRef.url1
            this.url2 = this.editStaticAppMenuItemRef.url2
            this.clickable = this.editStaticAppMenuItemRef.clickable
            break
          case 'pdf':
            this.pdfId = this.editStaticAppMenuItemRef.id
            this.documentsTitle = this.editStaticAppMenuItemRef.documentsTitle
            this.documentsTitleAl = this.editStaticAppMenuItemRef.documentsTitleAl
            this.title1 = this.editStaticAppMenuItemRef.title1
            this.title2 = this.editStaticAppMenuItemRef.title2
            this.title1Al = this.editStaticAppMenuItemRef.title1Al
            this.title2Al = this.editStaticAppMenuItemRef.title2Al
            this.description1 = this.editStaticAppMenuItemRef.desc1
            this.description1Al = this.editStaticAppMenuItemRef.desc1Al
            this.description2 = this.editStaticAppMenuItemRef.desc2
            this.description2Al = this.editStaticAppMenuItemRef.desc2Al
            this.url = this.editStaticAppMenuItemRef.url
            break
          case 'mosaic':
            this.resourceName1 = this.editStaticAppMenuItemRef.imageName1
            this.resourceName2 = this.editStaticAppMenuItemRef.imageName2
            this.resourceName3 = this.editStaticAppMenuItemRef.imageName3
            this.resourceName4 = this.editStaticAppMenuItemRef.imageName4
            this.resourceName5 = this.editStaticAppMenuItemRef.imageName5
            this.resourceName6 = this.editStaticAppMenuItemRef.imageName6
            this.imageUrl1 = this.editStaticAppMenuItemRef.imageUrl1
            this.imageUrl2 = this.editStaticAppMenuItemRef.imageUrl2
            this.imageUrl3 = this.editStaticAppMenuItemRef.imageUrl3
            this.imageUrl4 = this.editStaticAppMenuItemRef.imageUrl4
            this.imageUrl5 = this.editStaticAppMenuItemRef.imageUrl5
            this.imageUrl6 = this.editStaticAppMenuItemRef.imageUrl6
            this.webUrl1 = this.editStaticAppMenuItemRef.webUrl1
            this.webUrl2 = this.editStaticAppMenuItemRef.webUrl2
            this.webUrl3 = this.editStaticAppMenuItemRef.webUrl3
            this.webUrl4 = this.editStaticAppMenuItemRef.webUrl4
            this.webUrl5 = this.editStaticAppMenuItemRef.webUrl5
            this.webUrl6 = this.editStaticAppMenuItemRef.webUrl6
            this.isAddMosaic = false
            break
          default:
            break
        }
      }
    }
  },
  computed: {
    questionnaires () {
      return this.$store.state.questionnaires
    },
    appMenu () {
      return this.$store.state.appMenu
    },
    addOns () {
      return this.$store.state.addOns
    },
    role () {
      return this.$store.state.role
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    userId () {
      return this.$store.state.uid
    }
  },
  methods: {
    saveAppMenuItem () {
      if (this.appMenuItemType === '') {
        return
      }
      if (this.appItemTitle === '' || this.appItemTitleAl === '') {
        this.bFieldsError = true
        return
      }
      let path = '/neoslide/appMenu/' + this.workspaceId + '/items/' + this.itemIndex
      switch (this.appMenuItemType) {
        case 'questionnaire':
          if (this.questionnaireId === '') {
            this.bFieldsError = true
            return
          }
          this.$store.state.database.ref(path).set({
            type: this.appMenuItemType,
            appItemTitle: this.appItemTitle,
            appItemTitleAl: this.appItemTitleAl,
            iconUrl: '',
            questionnaireId: this.questionnaireId
          }).then(() => {
            this.$parent.close()
            if (this.resourceName1 !== '') {
              let filesToRemove = [this.resourceName1, this.resourceName2, this.resourceName3, this.resourceName4, this.resourceName5, this.resourceName6]
              this.deleteImages(filesToRemove)
            }
          }).catch(error => {
            this.handleError(error)
          })
          break
        case 'doubleWeb':
          if (this.title1 === '' || this.title1Al === '' || this.title2 === '' || this.title2Al === '' || this.url1 === '' || this.url2 === '' ||
          this.description1 === '' || this.description1Al === '' || this.description2 === '' || this.description2Al === '') {
            this.bFieldsError = true
            return
          }
          this.$store.state.database.ref(path).set({
            type: this.appMenuItemType,
            appItemTitle: this.appItemTitle,
            appItemTitleAl: this.appItemTitleAl,
            iconUrl: '',
            title1: this.title1,
            title1Al: this.title1Al,
            title2: this.title2,
            title2Al: this.title2Al,
            url1: this.url1,
            url2: this.url2,
            desc1: this.description1,
            desc2: this.description2,
            desc1Al: this.description1Al,
            desc2Al: this.description2Al
          }).then(() => {
            this.$parent.close()
            if (this.resourceName1 !== '') {
              let filesToRemove = [this.resourceName1, this.resourceName2, this.resourceName3, this.resourceName4, this.resourceName5, this.resourceName6]
              this.deleteImages(filesToRemove)
            }
          }).catch(error => {
            this.handleError(error)
          })
          break
        case 'mosaic':
          if (this.isAddMosaic) {
            if ((this.resourceName1 === '' && !this.itemFiles1[0]) || (this.resourceName2 === '' && !this.itemFiles2[0]) || (this.resourceName3 === '' && !this.itemFiles3[0]) || (this.resourceName4 === '' && !this.itemFiles4[0]) || (this.resourceName5 === '' && !this.itemFiles5[0]) || (this.resourceName6 === '' && !this.itemFiles6[0]) ||
            this.webUrl1 === '' || this.webUrl2 === '' || this.webUrl3 === '' || this.webUrl4 === '' || this.webUrl5 === '' || this.webUrl6 === '') {
              // this.bFilesError = true
              this.bFieldsError = true
              return
            }
            if (!this.checkImageFormat()) {
              return
            }
            if (!this.checkImageSize()) {
              return
            }

            // check duplicate
            let imageNames = [this.itemFiles1[0].name, this.itemFiles2[0].name, this.itemFiles3[0].name, this.itemFiles4[0].name, this.itemFiles5[0].name, this.itemFiles6[0].name]
            if (this.hasDuplicates(imageNames)) {
              return
            }

            let imageUrl1 = ''
            let imageUrl2 = ''
            let imageUrl3 = ''
            let imageUrl4 = ''
            let imageUrl5 = ''
            let imageUrl6 = ''
            this.loadingComponent = this.$buefy.loading.open()
            let ref1 = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuMosaicImages/' + '/' + this.itemFiles1[0].name)
            ref1.put(this.itemFiles1[0]).then((snapshot) => {
              ref1.getDownloadURL().then((url) => {
                this.globalLogger('File ' + this.itemFiles1[0].name + ' successfully uploaded at ' + url)
                this.updateExistingFiles(this.itemFiles1[0].name, url)
                imageUrl1 = url
              }).then(() => {
                let ref2 = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuMosaicImages/' + '/' + this.itemFiles2[0].name)
                ref2.put(this.itemFiles2[0]).then((snapshot) => {
                  ref2.getDownloadURL().then((url) => {
                    this.globalLogger('File ' + this.itemFiles2[0].name + ' successfully uploaded at ' + url)
                    this.updateExistingFiles(this.itemFiles2[0].name, url)
                    imageUrl2 = url
                  }).then(() => {
                    let ref3 = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuMosaicImages/' + '/' + this.itemFiles3[0].name)
                    ref3.put(this.itemFiles3[0]).then((snapshot) => {
                      ref3.getDownloadURL().then((url) => {
                        this.globalLogger('File ' + this.itemFiles3[0].name + ' successfully uploaded at ' + url)
                        this.updateExistingFiles(this.itemFiles3[0].name, url)
                        imageUrl3 = url
                      }).then(() => {
                        let ref4 = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuMosaicImages/' + '/' + this.itemFiles4[0].name)
                        ref4.put(this.itemFiles4[0]).then((snapshot) => {
                          ref4.getDownloadURL().then((url) => {
                            this.globalLogger('File ' + this.itemFiles4[0].name + ' successfully uploaded at ' + url)
                            this.updateExistingFiles(this.itemFiles4[0].name, url)
                            imageUrl4 = url
                          }).then(() => {
                            let ref5 = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuMosaicImages/' + '/' + this.itemFiles5[0].name)
                            ref5.put(this.itemFiles5[0]).then((snapshot) => {
                              ref5.getDownloadURL().then((url) => {
                                this.globalLogger('File ' + this.itemFiles5[0].name + ' successfully uploaded at ' + url)
                                this.updateExistingFiles(this.itemFiles5[0].name, url)
                                imageUrl5 = url
                              }).then(() => {
                                let ref6 = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuMosaicImages/' + '/' + this.itemFiles6[0].name)
                                ref6.put(this.itemFiles6[0]).then((snapshot) => {
                                  ref6.getDownloadURL().then((url) => {
                                    this.globalLogger('File ' + this.itemFiles6[0].name + ' successfully uploaded at ' + url)
                                    this.updateExistingFiles(this.itemFiles6[0].name, url)
                                    imageUrl6 = url
                                  }).then(() => {
                                    this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + this.itemIndex).update({
                                      type: this.appMenuItemType,
                                      appItemTitle: this.appItemTitle,
                                      appItemTitleAl: this.appItemTitleAl,
                                      iconUrl: '',
                                      imageUrl1: imageUrl1,
                                      imageUrl2: imageUrl2,
                                      imageUrl3: imageUrl3,
                                      imageUrl4: imageUrl4,
                                      imageUrl5: imageUrl5,
                                      imageUrl6: imageUrl6,
                                      imageName1: this.itemFiles1[0].name,
                                      imageName2: this.itemFiles2[0].name,
                                      imageName3: this.itemFiles3[0].name,
                                      imageName4: this.itemFiles4[0].name,
                                      imageName5: this.itemFiles5[0].name,
                                      imageName6: this.itemFiles6[0].name,
                                      webUrl1: this.webUrl1,
                                      webUrl2: this.webUrl2,
                                      webUrl3: this.webUrl3,
                                      webUrl4: this.webUrl4,
                                      webUrl5: this.webUrl5,
                                      webUrl6: this.webUrl6
                                    }).then(() => {
                                      if (this.resourceName1 !== '') { // there are 6 image files
                                        let filesToRemove = [this.resourceName1, this.resourceName2, this.resourceName3, this.resourceName4, this.resourceName5, this.resourceName6]
                                        this.deleteImages(filesToRemove)
                                      } else {
                                        this.$parent.close()
                                        this.loadingComponent.close()
                                      }
                                    }).catch(error => {
                                      this.handleError(error)
                                    })
                                  })
                                }).catch(error => {
                                  this.handleError(error)
                                })
                              })
                            }).catch(error => {
                              this.handleError(error)
                            })
                          })
                        }).catch(error => {
                          this.handleError(error)
                        })
                      })
                    }).catch(error => {
                      this.handleError(error)
                    })
                  })
                }).catch(error => {
                  this.handleError(error)
                })
              })
            }).catch(error => {
              this.handleError(error)
            })
          } else {
            if (this.itemFiles1[0] || this.itemFiles2[0] || this.itemFiles3[0] || this.itemFiles4[0] || this.itemFiles5[0] || this.itemFiles6[0]) {
              if (!this.checkImageFormat()) {
                return
              }
              if (!this.checkImageSize()) {
                return
              }
              if (this.webUrl1 === '' || this.webUrl2 === '' || this.webUrl3 === '' || this.webUrl4 === '' || this.webUrl5 === '' || this.webUrl6 === '') {
                this.bFieldsError = true
                return
              }
              let imageNames = [this.itemFiles1[0] ? this.itemFiles1[0].name : this.resourceName1, this.itemFiles2[0] ? this.itemFiles2[0].name : this.resourceName2, this.itemFiles3[0] ? this.itemFiles3[0].name : this.resourceName3, this.itemFiles4[0] ? this.itemFiles4[0].name : this.resourceName4, this.itemFiles5[0] ? this.itemFiles5[0].name : this.resourceName5, this.itemFiles6[0] ? this.itemFiles6[0].name : this.resourceName6]
              if (this.hasDuplicates(imageNames)) {
                return
              }
              this.loadingComponent = this.$buefy.loading.open()
              let uploadPromiseList = []
              let filesToRemove = []
              if (this.itemFiles1[0]) {
                uploadPromiseList.push(this.uploadImage(this.itemFiles1[0], 1))
                filesToRemove.push(this.resourceName1)
              }
              if (this.itemFiles2[0]) {
                uploadPromiseList.push(this.uploadImage(this.itemFiles2[0], 2))
                filesToRemove.push(this.resourceName2)
              }
              if (this.itemFiles3[0]) {
                uploadPromiseList.push(this.uploadImage(this.itemFiles3[0], 3))
                filesToRemove.push(this.resourceName3)
              }
              if (this.itemFiles4[0]) {
                uploadPromiseList.push(this.uploadImage(this.itemFiles4[0], 4))
                filesToRemove.push(this.resourceName4)
              }
              if (this.itemFiles5[0]) {
                uploadPromiseList.push(this.uploadImage(this.itemFiles5[0], 5))
                filesToRemove.push(this.resourceName5)
              }
              if (this.itemFiles6[0]) {
                uploadPromiseList.push(this.uploadImage(this.itemFiles6[0], 6))
                filesToRemove.push(this.resourceName6)
              }
              let imageUrl1 = this.imageUrl1
              let imageUrl2 = this.imageUrl2
              let imageUrl3 = this.imageUrl3
              let imageUrl4 = this.imageUrl4
              let imageUrl5 = this.imageUrl5
              let imageUrl6 = this.imageUrl6
              let imageName1 = this.resourceName1
              let imageName2 = this.resourceName2
              let imageName3 = this.resourceName3
              let imageName4 = this.resourceName4
              let imageName5 = this.resourceName5
              let imageName6 = this.resourceName6
              Promise.all(uploadPromiseList).then(values => {
                let valueForImage1 = values.find(x => x.indx === 1)
                if (valueForImage1) {
                  imageUrl1 = valueForImage1.url
                  imageName1 = valueForImage1.name
                  this.updateExistingFiles(imageName1, imageUrl1)
                }
                let valueForImage2 = values.find(x => x.indx === 2)
                if (valueForImage2) {
                  imageUrl2 = valueForImage2.url
                  imageName2 = valueForImage2.name
                  this.updateExistingFiles(imageName2, imageUrl2)
                }
                let valueForImage3 = values.find(x => x.indx === 3)
                if (valueForImage3) {
                  imageUrl3 = valueForImage3.url
                  imageName3 = valueForImage3.name
                  this.updateExistingFiles(imageName3, imageUrl3)
                }
                let valueForImage4 = values.find(x => x.indx === 4)
                if (valueForImage4) {
                  imageUrl4 = valueForImage4.url
                  imageName4 = valueForImage4.name
                  this.updateExistingFiles(imageName4, imageUrl4)
                }
                let valueForImage5 = values.find(x => x.indx === 5)
                if (valueForImage5) {
                  imageUrl5 = valueForImage5.url
                  imageName5 = valueForImage5.name
                  this.updateExistingFiles(imageName5, imageUrl5)
                }
                let valueForImage6 = values.find(x => x.indx === 6)
                if (valueForImage6) {
                  imageUrl6 = valueForImage6.url
                  imageName6 = valueForImage6.name
                  this.updateExistingFiles(imageName6, imageUrl6)
                }

                this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + this.itemIndex).update({
                  type: this.appMenuItemType,
                  appItemTitle: this.appItemTitle,
                  appItemTitleAl: this.appItemTitleAl,
                  iconUrl: '',
                  imageUrl1: imageUrl1,
                  imageUrl2: imageUrl2,
                  imageUrl3: imageUrl3,
                  imageUrl4: imageUrl4,
                  imageUrl5: imageUrl5,
                  imageUrl6: imageUrl6,
                  imageName1: imageName1,
                  imageName2: imageName2,
                  imageName3: imageName3,
                  imageName4: imageName4,
                  imageName5: imageName5,
                  imageName6: imageName6,
                  webUrl1: this.webUrl1,
                  webUrl2: this.webUrl2,
                  webUrl3: this.webUrl3,
                  webUrl4: this.webUrl4,
                  webUrl5: this.webUrl5,
                  webUrl6: this.webUrl6
                }).then(() => {
                  this.$parent.close()
                  this.loadingComponent.close()
                  this.deleteImages(filesToRemove)
                }).catch(error => {
                  this.handleError(error)
                })
              })
            } else {
              if (this.webUrl1 === '' || this.webUrl2 === '' || this.webUrl3 === '' || this.webUrl4 === '' || this.webUrl5 === '' || this.webUrl6 === '') {
                this.bFieldsError = true
                return
              }
              this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + this.itemIndex).update({
                appItemTitle: this.appItemTitle,
                appItemTitleAl: this.appItemTitleAl,
                webUrl1: this.webUrl1,
                webUrl2: this.webUrl2,
                webUrl3: this.webUrl3,
                webUrl4: this.webUrl4,
                webUrl5: this.webUrl5,
                webUrl6: this.webUrl6
              }).then(() => {
                this.$parent.close()
              }).catch(error => {
                this.handleError(error)
              })
            }
          }
          break
        case 'pdf':
          /* if (this.resourceName === '' && !this.itemFiles[0]) {
            this.bFieldsError = true
            this.bFileError = false
            return
          }
          if (this.itemFiles[0] && this.itemFiles[0].type !== 'application/pdf') {
            this.bFileError = true
            this.bFieldsError = false
            this.bFileMessage = 'Incompatible file format! The supported type is .pdf.'
            this.itemFiles = []
            return
          }
          if (this.itemFiles[0] && this.itemFiles[0].size >= 52428800) {
            this.bFileError = true
            this.bFieldsError = false
            this.bFileMessage = 'Resource too big! Maximum resource size is 50 MB.'
            this.itemFiles = []
            return
          }
          if (this.itemFiles[0]) { // se menuva slika
            this.loadingComponent = this.$buefy.loading.open()
            let ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuPdfs/' + '/' + this.itemFiles[0].name)
            ref.put(this.itemFiles[0]).then((snapshot) => {
              ref.getDownloadURL().then((url) => {
                this.globalLogger('File ' + this.itemFiles[0].name + ' successfully uploaded at ' + url)

                // change image url of existing pdf with the same file
                for (let id in this.appMenu.items) {
                  if (this.appMenu.items[id].type === 'pdf') {
                    if (this.appMenu.items[id].fileName === this.itemFiles[0].name) {
                      this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + id).update({
                        fileUrl: url
                      })
                    }
                  }
                }
                this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + this.itemIndex).update({
                  type: this.appMenuItemType,
                  appItemTitle: this.appItemTitle,
                  appItemTitleAl: this.appItemTitleAl,
                  iconUrl: '',
                  fileUrl: url,
                  fileName: this.itemFiles[0].name
                }).then(() => {
                  if (this.resourceName !== '') { // there is existing pdf file
                    this.deletePdf()
                  } else if (this.resourceName1 !== '') {
                    let filesToRemove = [this.resourceName1, this.resourceName2, this.resourceName3, this.resourceName4, this.resourceName5, this.resourceName6]
                    this.deleteImages(filesToRemove)
                  } else {
                    this.$parent.close()
                    this.loadingComponent.close()
                  }
                }).catch(error => {
                  this.handleError(error)
                })
              })
            }).catch(error => {
              this.handleError(error)
            })
          } else { // ne se menuva slika */
          if (this.documentsTitle === '' || this.documentsTitleAl === '' || this.title1 === '' || this.title1Al === '' || this.title2 === '' || this.title2Al === '' || this.description1 === '' || this.description1Al === '' || this.description2 === '' || this.description2Al === '' || this.url === '') {
            this.bFieldsError = true
            return
          }
          if (this.pdfId === '') {
            this.pdfId = this.generatePdfId()
          }
          this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + this.itemIndex).update({
            type: this.appMenuItemType,
            appItemTitle: this.appItemTitle,
            appItemTitleAl: this.appItemTitleAl,
            iconUrl: '',
            id: this.pdfId,
            documentsTitle: this.documentsTitle,
            documentsTitleAl: this.documentsTitleAl,
            title1: this.title1,
            title2: this.title2,
            title1Al: this.title1Al,
            title2Al: this.title2Al,
            desc1: this.description1,
            desc1Al: this.description1Al,
            desc2: this.description2,
            desc2Al: this.description2Al,
            url: this.url
          }).then(() => {
            this.$parent.close()
          }).catch(error => {
            this.handleError(error)
          })
          break
        case 'singleQR':
          if (this.title === '' || this.titleAl === '' || this.subtitle === '' || this.subtitleAl === '' || this.description === '' || this.descriptionAl === '' || this.url === '') {
            this.bFieldsError = true
            return
          }
          this.$store.state.database.ref(path).set({
            type: this.appMenuItemType,
            appItemTitle: this.appItemTitle,
            appItemTitleAl: this.appItemTitleAl,
            iconUrl: '',
            title: this.title,
            titleAl: this.titleAl,
            subTitle: this.subtitle,
            subTitleAl: this.subtitleAl,
            desc: this.description,
            descAl: this.descriptionAl,
            clickable: this.clickable,
            url: this.url
          }).then(() => {
            this.$parent.close()
            if (this.resourceName1 !== '') {
              let filesToRemove = [this.resourceName1, this.resourceName2, this.resourceName3, this.resourceName4, this.resourceName5, this.resourceName6]
              this.deleteImages(filesToRemove)
            }
          }).catch(error => {
            this.handleError(error)
          })
          break
        case 'doubleQR':
          if (this.title === '' || this.titleAl === '' || this.subtitle1 === '' || this.subtitle1Al === '' || this.subtitle2 === '' || this.subtitle2Al === '' || this.description === '' || this.descriptionAl === '' || this.url1 === '' || this.url2 === '') {
            this.bFieldsError = true
            return
          }
          this.$store.state.database.ref(path).set({
            type: this.appMenuItemType,
            appItemTitle: this.appItemTitle,
            appItemTitleAl: this.appItemTitleAl,
            iconUrl: '',
            title: this.title,
            titleAl: this.titleAl,
            subTitle1: this.subtitle1,
            subTitle1Al: this.subtitle1Al,
            subTitle2: this.subtitle2,
            subTitle2Al: this.subtitle2Al,
            desc: this.description,
            descAl: this.descriptionAl,
            clickable: this.clickable,
            url1: this.url1,
            url2: this.url2
          }).then(() => {
            this.$parent.close()
            if (this.resourceName1 !== '') {
              let filesToRemove = [this.resourceName1, this.resourceName2, this.resourceName3, this.resourceName4, this.resourceName5, this.resourceName6]
              this.deleteImages(filesToRemove)
            }
          }).catch(error => {
            this.handleError(error)
          })
          break
        default:
          break
      }
    },
    generatePdfId () {
      return Math.random().toString(36).slice(2, 12)
    },
    checkImageFormat () {
      let multipleItemFiles = [this.itemFiles1[0], this.itemFiles2[0], this.itemFiles3[0], this.itemFiles4[0], this.itemFiles5[0], this.itemFiles6[0]]
      for (let idx in multipleItemFiles) {
        if (multipleItemFiles[idx]) {
          if (multipleItemFiles[idx].type !== 'image/jpeg' && multipleItemFiles[idx].type !== 'image/png') {
            this.bFilesError = true
            this.bFieldsError = false
            this.bFilesMessage = 'Incompatible file format! The supported types are .png/.jpg.'
            return false
          }
        }
      }
      return true
    },
    checkImageSize () {
      let multipleItemFiles = [this.itemFiles1[0], this.itemFiles2[0], this.itemFiles3[0], this.itemFiles4[0], this.itemFiles5[0], this.itemFiles6[0]]
      for (let idx in multipleItemFiles) {
        if (multipleItemFiles[idx]) {
          if (multipleItemFiles[idx].size >= 5242880) {
            this.bFilesError = true
            this.bFieldsError = false
            this.bFilesMessage = 'Resource too big! Maximum image size is 5 MB.'
            return false
          }
        }
      }
      return true
    },
    hasDuplicates (imagesArray) {
      const seen = new Set() // Create a Set to store unique values
      for (let i = 0; i < imagesArray.length; i++) {
        if (seen.has(imagesArray[i])) {
          this.bFilesError = true
          this.bFieldsError = false
          this.bFilesMessage = 'Found image duplicates. All image files should have unique names.'
          return true // Found a duplicate
        }
        seen.add(imagesArray[i]) // Add the item to the Set
      }
      return false // No duplicates found
    },
    uploadImage (file, indx) {
      return new Promise((resolve, reject) => {
        const ref1 = this.$store.state.storage.ref(`/clients/${this.$store.state.workspaceId}/AppMenuMosaicImages/${file.name}`)
        ref1.put(file).then((snapshot) => {
          ref1.getDownloadURL().then((url) => {
            let obj = {
              url: url,
              name: file.name,
              indx: indx
            }
            resolve(obj)
          }).catch(reject)
        }).catch(reject)
      })
    },
    updateExistingFiles (fileName, url) {
      // change image url of existing image with the same file
      for (let id in this.appMenu.items) {
        if (this.appMenu.items[id].type === 'mosaic') {
          if (this.appMenu.items[id].imageName1 === fileName) {
            this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + id).update({
              imageUrl1: url
            })
          } else if (this.appMenu.items[id].imageName2 === fileName) {
            this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + id).update({
              imageUrl2: url
            })
          }
          if (this.appMenu.items[id].imageName3 === fileName) {
            this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + id).update({
              imageUrl3: url
            })
          }
          if (this.appMenu.items[id].imageName4 === fileName) {
            this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + id).update({
              imageUrl4: url
            })
          }
          if (this.appMenu.items[id].imageName5 === fileName) {
            this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + id).update({
              imageUrl5: url
            })
          }
          if (this.appMenu.items[id].imageName6 === fileName) {
            this.$store.state.database.ref('/neoslide/appMenu/' + this.$store.state.workspaceId + '/items/' + id).update({
              imageUrl6: url
            })
          }
        }
      }
    },
    isUsedImageFile (fileName) {
      for (let id in this.appMenu.items) {
        let item = this.appMenu.items[id]
        if (item.type === 'mosaic') {
          if (item.imageName1 === fileName || item.imageName2 === fileName || item.imageName3 === fileName || item.imageName4 === fileName || item.imageName5 === fileName || item.imageName6 === fileName) {
            this.globalLogger('delete previous file is false', id)
            return true
          }
        }
      }
      return false
    },
    deleteImages (filesToRemove) {
      let deletePromiseList = []
      let removeAppMenuImagesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuMosaicImages/')
      removeAppMenuImagesRef.listAll().then(dir => {
        dir.items.forEach(fileRef => {
          if (filesToRemove.includes(fileRef.name)) {
            if (!this.isUsedImageFile(fileRef.name)) {
              this.globalLogger('removing file ', fileRef.name)
              deletePromiseList.push(fileRef.delete())
            }
          }
        })
      })
      Promise.all(deletePromiseList).then(() => {
        this.globalLogger('removed previous')
      })
    },
    deletePdf () { // unused method
      // this.$store.state.database.ref('/neoslide/appMenuPdfs/' + this.$store.state.workspaceId + '/' + this.pdfId).remove()
      this.deletePreviousFile = true
      this.globalLogger('delete previous file is true')

      // check if previous file is used by another app menu item
      for (let id in this.appMenu.items) {
        if (this.appMenu.items[id].type === 'pdf') {
          if (this.appMenu.items[id].fileName === this.resourceName) {
            this.globalLogger('delete previous file is false', id)
            this.deletePreviousFile = false
          }
        }
      }

      // delete previous file
      if (this.deletePreviousFile) {
        this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuPdfs/' + this.resourceName).delete()
          .then(() => {
            this.$parent.close()
            if (this.loadingComponent !== undefined) {
              this.loadingComponent.close()
            }
          })
          .catch(error => {
            this.globalLogger('could not delete previous file', error)
            this.$parent.close()
            if (this.loadingComponent !== undefined) {
              this.loadingComponent.close()
            }
          })
      } else {
        this.$parent.close()
        if (this.loadingComponent !== undefined) {
          this.loadingComponent.close()
        }
      }
    },
    showAlert () {
      this.$buefy.dialog.alert({
        title: 'Operation faild',
        message: 'Editing app menu item failed. Please try again.',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    handleError (error) {
      this.globalLogger(error)
      this.$parent.close()
      this.loadingComponent.close()
      this.showAlert()
    },
    closeModal () {
      this.$parent.close()
    },
    addFile () {
      if (this.role !== 'viewer') {
        document.getElementById('fileSelect').click()
      }
    },
    fileUploaded (e) {
      let files = e.target.files
      this.bFileError = false
      this.itemFiles = [files[0]]
    },
    addFile1 () {
      if (this.role !== 'viewer') {
        document.getElementById('file1Select').click()
      }
    },
    file1Uploaded (e) {
      let files = e.target.files
      this.itemFiles1 = [files[0]]
    },
    addFile2 () {
      if (this.role !== 'viewer') {
        document.getElementById('file2Select').click()
      }
    },
    file2Uploaded (e) {
      let files = e.target.files
      this.itemFiles2 = [files[0]]
    },
    addFile3 () {
      if (this.role !== 'viewer') {
        document.getElementById('file3Select').click()
      }
    },
    file3Uploaded (e) {
      let files = e.target.files
      this.itemFiles3 = [files[0]]
    },
    addFile4 () {
      if (this.role !== 'viewer') {
        document.getElementById('file4Select').click()
      }
    },
    file4Uploaded (e) {
      let files = e.target.files
      this.itemFiles4 = [files[0]]
    },
    addFile5 () {
      if (this.role !== 'viewer') {
        document.getElementById('file5Select').click()
      }
    },
    file5Uploaded (e) {
      let files = e.target.files
      this.itemFiles5 = [files[0]]
    },
    addFile6 () {
      if (this.role !== 'viewer') {
        document.getElementById('file6Select').click()
      }
    },
    file6Uploaded (e) {
      let files = e.target.files
      this.itemFiles6 = [files[0]]
    }
  }
}
</script>

<style scoped>
.box {
  border: 0.5px solid rgb(212, 212, 212);
}
.bottomPadding {
  padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/appmenu/AppMenuItemEdit.vue